<form class="form-group" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="close-container">
    <mat-icon class="close-icon" (click)="closeDialog()"></mat-icon>
  </div>
  <div class="title title--lg dialog" mat-dialog-title>Resident Transition</div>
  <div class="title title--xs" mat-dialog-title>{{data.firstName}} {{data.lastName}}</div>
  <mat-dialog-content>
    <div class="smallerText">What are the resident's plans following residency?</div>
    <mat-radio-group aria-label="Select an option" class="radio" formControlName="{{isFellowshipProgramControl}}">
      <mat-radio-button [value]="false" (change)="radioChange($event)">
        <div class="smallerText list-font">The resident is entering practice</div>
      </mat-radio-button>
      <mat-radio-button [value]="true" (change)="radioChange($event)">
        <div class="smallerText list-font">The resident is entering an orthopaedic fellowship program</div>
      </mat-radio-button>
    </mat-radio-group>
    <div *ngIf="this.formGroup.controls['isFellowshipProgram'].value == true">
      <div class="title title--x">Fellowship Program Information</div>
      <div class="sub-content">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="title">Institution</div>
            <input class="form-control" type="text" formControlName="{{fellowshipProgramNameControl}}" />
            <div class="required-text" *ngIf="invalidRequiredField(fellowshipProgramNameControl)">
              Institution is required
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="title">Location</div>
            <input class="form-control" type="text" formControlName="{{fellowshipProgramLocationContol}}" />
            <div class="required-text" *ngIf="invalidRequiredField(fellowshipProgramLocationContol)">
              Location is required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="title">Sub Specialty</div>
            <mat-select class="small--font" placeholder="Select a Sub Specialty" formControlName="{{fellowshipProgramSubspecialtyControl}}" disableRipple panelClass="mat-panel">
              <mat-option value="">Select a Sub Specialty</mat-option>
              <mat-option *ngFor="let i of this.subSpecialtiesList" [value]="i.preferenceSubCode">{{i.preferenceDescription}}</mat-option>
            </mat-select>
            <div class="required-text" *ngIf="invalidRequiredField(fellowshipProgramSubspecialtyControl)">
              Sub Specialty is required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="title title--x">Fellowship Begin Date</div>
            <div class="dateContainer">
              <div class="date--form-control" (click)="startDatePicker.open()">
                <input class="form-control" disabled="true" [matDatepicker]="startDatePicker" formControlName="{{fellowshipBeginDateControl}}" type="text" />
              </div>
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker disabled="false" #startDatePicker></mat-datepicker>
            </div>
            <div class="required-text" *ngIf="invalidRequiredField(fellowshipBeginDateControl)">
              Fellowship Begin Date is required
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="title title--x">Fellowship Completion Date</div>
            <div class="dateContainer">
              <div class="date--form-control" (click)="endDatePicker.open()">
                <input class="form-control" disabled="true" [matDatepicker]="endDatePicker" formControlName="{{fellowshipEndDateControl}}" type="text" />
              </div>
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker disabled="false" #endDatePicker></mat-datepicker>
            </div>
            <div class="required-text" *ngIf="invalidRequiredField(fellowshipEndDateControl)">
              Fellowship Completion Date is required
            </div>
          </div>
        </div>
        <div>
          <ul>
            <li *ngFor="let item of errors" class="required-text">{{item}}</li>
          </ul>
        </div>
      </div>  
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="btn--inline dialog-btn-container" [ngClass]="{'btn-align-right': this.isFellowshipProgram}">
      <input type="button" class="btn btn--outline hide-on-mobile " (click)="closeDialog()" value="Cancel">
      <button class="btn btn--solid btn--red" type="submit" [disabled]="!canSaveTransition()">Save</button>
    </div>
  </div>
</form>
<aaos-spinner [isLoading]="loading"></aaos-spinner>